import type { IAdProvider, AdStatus, AdProviderConfig } from '../types';

declare global {
  interface Window {
    showGiga: () => Promise<any>;
  }
}

export class GigahubProvider implements IAdProvider {
  readonly providerId = 'gigapub' as const;
  private status: AdStatus = 'idle';
  private statusCallbacks: Array<(status: AdStatus) => void> = [];
  private config: AdProviderConfig;

  constructor(config: AdProviderConfig) {
    this.config = config;
  }

  getStatus(): AdStatus {
    return this.status;
  }

  onStatusChange(callback: (status: AdStatus) => void): void {
    this.statusCallbacks.push(callback);
  }

  private setStatus(status: AdStatus) {
    this.status = status;
    this.statusCallbacks.forEach(cb => cb(status));
  }

  async init(): Promise<void> {
    if (typeof window === 'undefined') return;

    if (typeof window.showGiga === 'function') {
      this.setStatus('ready');
      return;
    }

    this.setStatus('loading');
    const script = document.createElement('script');
    script.src = `https://ad.gigapub.tech/script?id=${this.config.projectId}`;
    document.head.appendChild(script);

    return new Promise((resolve, reject) => {
      script.onload = () => {
        console.log('[Gigahub] SDK loaded');
        this.setStatus('ready');
        resolve();
      };
      script.onerror = () => {
        console.error('[Gigahub] Failed to load SDK');
        this.setStatus('error');
        reject(new Error('Failed to load Gigahub SDK'));
      };
    });
  }

  async open(): Promise<any> {
    if (!window.showGiga) {
      throw new Error('Gigahub SDK is not available');
    }

    try {
      const data = await window.showGiga();
      return data;
    } catch (error) {
      console.error('[Gigahub] Ad failed', error);
      throw error;
    }
  }
}
